import { render, staticRenderFns } from "./DateMeal-payment.vue?vue&type=template&id=65c21e1d&scoped=true&"
import script from "./DateMeal-payment.vue?vue&type=script&lang=js&"
export * from "./DateMeal-payment.vue?vue&type=script&lang=js&"
import style0 from "./DateMeal-payment.vue?vue&type=style&index=0&id=65c21e1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c21e1d",
  null
  
)

export default component.exports